import { jsx as r, jsxs as o } from "react/jsx-runtime";
import "react";
import { p as _ } from "../../index-B0ARwqly.mjs";
import { classes as e } from "../../utils/helpers.js";
import '../../assets/ErrorHandler.css';const s = {
  "error-handler__message": "_error-handler__message_4uq8z_1"
};
function h({ title: a, message: l }) {
  return /* @__PURE__ */ r("error-handler", { children: /* @__PURE__ */ o("div", { className: e([s["error-handler__message"], "error-handler__message"]), children: [
    /* @__PURE__ */ r("h2", { className: e([s["error-handler__title"], "error-handler__title"]), children: a }),
    /* @__PURE__ */ r("p", { className: e([s["error-handler__message-text"], "error-handler__message-text"]), children: _(l) })
  ] }) });
}
export {
  h as ErrorHandler,
  h as default
};
